
import { BALANCE_METAMASK, GET_META_MASK_DATA, INVESTMENT_AMOUNT, MINT_LOADER, SALE_STATUS, SET_MINT_PRICE, TOTAL_SUPPLY } from "./../action/user-task";

window.Buffer = window.Buffer || require('buffer').Buffer;
const initialState = {
    metaMaskAccount: false,
    connectionType: false,
    username: false,
    balance: 0,
    mintPrice: 0,
    mintLoader: false,
    earlySale: false,
    preSale: false,
    publicSale: false,
    totalSupply: 0,
    minted: 0,
    tokensLeft: 0

};

const ContentReducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_META_MASK_DATA:
            return {
                ...state,
                metaMaskAccount: action.payload.HydroTokenId,
                connectionType: action.payload.connectionType,
                username: action.payload.username,
            };

        case BALANCE_METAMASK:
            return {
                ...state,
                balance: action.payload
            };
        case SET_MINT_PRICE:
            return {
                ...state,
                mintPrice: action.payload
            };
        case MINT_LOADER:
            return {
                ...state,
                mintLoader: action.payload
            };
        case SALE_STATUS:
            return {
                ...state,
                earlySale: action.payload.earlySale,
                preSale: action.payload.preSale,
                publicSale: action.payload.publicSale
            };
        case TOTAL_SUPPLY:
            return {
                ...state,
                totalSupply: action.payload.totalSupply,
                minted: action.payload.minted,
                tokensLeft: action.payload.tokensLeft,
                balanceOf: action.payload.balanceOf
            };


        default:
            return {
                ...state
            }

    }
}
export default ContentReducer